import {
  AfterViewInit,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {Router} from "@angular/router";
import {ResizeDetectionService} from "../../../services/resize-detection.service";
import {HomeService} from "../../../services/home/home.service";
import {PlanService} from "../../../services/plan/plan.service";
import {MealModel} from "../../../models/home/meal-model";
import { CommonModule } from "@angular/common";
import {OurMenuService} from "../../../../our-menu.service";
import {OrangeButtonComponent} from "../orange-button/orange-button.component";
import {NewMealCardComponent} from "../new-meal-card/new-meal-card.component";

@Component({
  selector: 'app-current-menu-slider',
  templateUrl: './current-menu-slider.component.html',
  styleUrls: ['./current-menu-slider.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true,
  imports: [CommonModule, OrangeButtonComponent, NewMealCardComponent],
  encapsulation: ViewEncapsulation.None // <-- NECESSARIO per custom CSS globali
})
export class CurrentMenuSliderComponent implements AfterViewInit {

  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;

  mealsModel: MealModel[] = [];

  breakpointsJson = JSON.stringify({
    640: {
      slidesPerView: 2,
      spaceBetween: 20
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 30
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 40
    }
  });

  constructor(
      private router: Router,
      private sizedetection: ResizeDetectionService,
      private homeService: HomeService,
      private planService: PlanService,
      private ourmenu: OurMenuService,
  ) {
    router.events.subscribe(() => {
      this.sizedetection.refreshSize();
      this.sizedetection.sizeCondition$.subscribe(data => {
        this.isDesktop = data.isDesktop;
        this.isTablet = data.isTablet;
        this.isMobile = data.isMobile;
      });
    });

    this.ourmenu.mystatusChanged.subscribe(status => this.moveToMeals(status));

    this.getMeals();

  }

  ngAfterViewInit() {
    const swiperEl: any = document.querySelector('swiper-container');
    swiperEl.initialize(); // manually initialize since init="false"
  }

  @ViewChild("meals") MyProp: ElementRef;
  moveToMeals(status: string) {
    console.log(status);
    if (status == 'set') {
      setTimeout(() => {
        this.MyProp.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 500);
    } else window.scrollTo(0, 0);
  }



  goToCurrentMenu() {
    this.router.navigate(["current-menu"]);
  }

  getMeals() {
    this.mealsModel = [];

    this.planService.getSelectedMeals().subscribe((selectedMealsList: any) => {
      this.mealsModel = selectedMealsList;
    });
  }


}